export default {
  // MessageUsageJourney,Activity
  excelDownload: '엑셀 다운로드',
  journeyName: 'Journey 이름',
  journeyID: 'Journey 아이디',
  journeyVersion: 'Journey 버전',
  journeyVersionID: 'Journey 버전 아이디',
  activityName: 'Activity 이름',
  activityId: 'Activity ID',
  journeyVersionStatistics: 'Journey 버전 통계',
  journeyVersionLastCount: '메시지 최신 버전 발송량',
  allCount: '전체',
  successCount: '성공',
  failbackCount: '재전송',
  waitingCount: '대기중',
  failCount: '실패',
  rejectCount: '수신거부',
  wrongRequests: '잘못된 요청',
  finishSendDate: '마지막 발신일시',
  agentType: '에이전트 타입',
  messageClType: '메시지 분류',
  messageType: '메시지 타입',
  content: '내용',
  viewDetails: '상세보기',
  monthStatistics: '월 통계',
  outgoingInformation: '발신 정보',
  recipientInformation: '수신 정보',
  resultInformation: '결과 파일 포함 정보',
  dateInformation: '발신/결과 일시',
  outgoingPhoneInfo: '발신번호',
  rejectPhoneInfo: '수신거부번호',
  msgClType: '발신타입',
  messageInformation: '메시지 정보',
  tmpBook: '예약상태',
  notiId: '발신 ID',
  recipientNum: '수신자 번호',
  reportCode: '발신결과(코드)',
  sentDate: '발신일시',
  lastSentDate: '최종 발신일시',
  resultDate: '결과일시',
  failbackMessageType: '페일백 메시지 타입',
  failbackReportCode: '재발신결과(코드)',
  failbackSentDate: '재발신일시',
  failbackResultDate: '재발신 결과일시',
  message: '문자 메시지',
  kakaoMessage: '카카오 메시지',
  kakaoProfile: '카카오 프로필',
  typeSearch: '타입별 검색',
  typeInputAlert: '타입별 검색어를 임력해주세요.',
  searchPeriod: '기간',
  contentCaption: '내용은 최대 100자까지 노출됩니다.',
  monthOfUse: '사용년월',
  recipientNumberSearchPlaceholder: '번호를 입력해주세요.',
  waitingCaption: '대기중은 발송대기 혹은 결과수신 대기중인 데이터입니다',
  recipientCaptionContent: '수신자 번호 검색은 번호를 \n\'-\'없이 입력해주셔야 합니다.',
  messageGroupName: '메시지 그룹명',
  messageGroupType: '메시지 그룹 타입',
  messageGroupTypeEx: 'Ex: Object, Flow',
  messageGroupVersion: '메시지 최신 버전',
  messageInfo: '메시지 정보',
  messageVersionInfo: '메시지 버전 정보',
  messageActivityInfo: 'Activity 정보',
  messageVersion: '메시지 버전',
  messageVersionId: '메시지 버전 ID',
  messageVersionStatistics: '메시지 버전 통계',
  messageId: '메시지 ID',
  sendResult: '발신결과',
  failbackType: '대체발송 타입',
  failbackInformation: '대체발송 정보',
  failbackDateInformation: '재발신/결과 일시',
};
